export default __webpack_public_path__ + "static/media/1619.3e5374eb.png";